export default "__VITE_ASSET__$2SZVL2Z__"